import React from 'react';
// =================== Finance page resources ==================

import RISK_INSIGHT_TEMPLATE from '../../images/product-assets/risk-insight-template.svg';
import ID_VERIFICATION_IMG from '../../images/product-assets/id-scan.svg';

import IFP_STEP_3 from '../../images/product-assets/ifp-step-3.svg';

import ICON_BAR from '../../images/Icons/icon-graph.svg';
import ICON_PAPER from '../../images/Icons/icon-paper-with-graph.svg';
import ICON_USER_FRAME from '../../images/Icons/icon-user-frame.svg';

import ICON_DOLLAR from '../../images/Icons/pricing.svg';
import ICON_SHIELD from '../../images/Icons/icon_security-shield.svg';

import ID_FRAUD_IMG_1 from '../../images/product-assets/id-fraud-img-1.svg';
import ID_FRAUD_IMG_2 from '../../images/product-assets/id-fraud-img-2.svg';

import FRAUD_PREVENTION_IMG_1 from '../../images/product-assets/finance-fraud-prevention-img-1.svg';
import FRAUD_PREVENTION_IMG_2 from '../../images/product-assets/finance-fraud-prevention-img-2.svg';

import FINANCE_BLOG_IMG from '../../images/product-assets/finance-blog-resource-img.png';
import {
    COMMON_KB_RESOURCE,
    COMMON_PRODUCT_RESOURCE,
    COMMON_SOLUTION_RESOURCE,
} from '../../helper/constant';

// ======================= MARKETPLACE PAGE RESOURCES ====================
import MARKETPLACE_FRAUD_PREVENTION_IMG_1 from '../../images/product-assets/marketplace-fraud-prevention-img-1.png';
import MARKETPLACE_FRAUD_PREVENTION_IMG_2 from '../../images/product-assets/marketplace-fraud-prevention-img-2.png';

import MARKETPLACE_FRAUD_IMG_1 from '../../images/product-assets/marketplace-fraud-img-1.svg';
import MARKETPLACE_FRAUD_IMG_2 from '../../images/product-assets/marketplace-fraud-img-2.svg';

import MARKETPLACE_BLOG_IMG from '../../images/product-assets/marketplace-blog-resource-img.png';
import MARKETPLACE_SOLUTION_IMG from '../../images/product-assets/marketplace-solution-resource-img.png';

// ======================= HEALTHCARE PAGE RESOURCES =======================
import Healthcare_step_1 from '../../images/product-assets/healthcare-page-step-1.svg';
import Healthcare_step_2 from '../../images/product-assets/doc-verification-step-3.svg';
import Healthcare_step_3 from '../../images/product-assets/healthcare-page-step-3.svg';

import Healthcare_fraud_img_1 from '../../images/product-assets/healthcare-fraud-img-1.svg';
import Healthcare_fraud_img_2 from '../../images/product-assets/healthcare-fraud-img-2.svg';

import Healthcare_fraud_prevention_img_1 from '../../images/product-assets/healthcare-fraud-prevention-img-1.svg';
import Healthcare_fraud_prevention_img_2 from '../../images/product-assets/healthcare-fraud-prevention-img-2.svg';

import Healthcare_Resource_img_1 from '../../images/product-assets/healthcare-page-resource-img-1.png';

export const AUTHENTICATION_STEPS = [
    {
        id: 1,
        icon: ICON_BAR,
        heading: 'Get Behavioral Insights',
        desc: 'Verify identities by matching contact data to our identity graph, with confidence scores and detailed insights.',
        points: [
            'Confidence Scores on User PII',
            'Social Profile Data with IP Address Validation',
            'Flag Suspicious Activities and Assess Risk',
        ],
        cta: {
            text: 'Learn More',
            link: 'https://info.authenticate.com/user-insights',
            external: true,
        },
        img: RISK_INSIGHT_TEMPLATE,
    },
    {
        id: 2,
        icon: ICON_PAPER,
        heading: 'Perform User Verification',
        desc: 'Verify 7,500+ government IDs from 200+ countries in 30 seconds, analyzing facial landmarks for KYC onboarding.',
        points: [
            'Financial Account Ownership Verification',
            'Government ID Verification with Liveness and Face Match',
            'Remote Onboarding with Global KYC',
        ],
        cta: {
            isPopup: true,
            text: 'Schedule a Demo',
        },
        img: ID_VERIFICATION_IMG,
    },
    {
        id: 3,
        icon: ICON_USER_FRAME,
        heading: 'Access Screening Reports',
        desc: 'Access detailed PDF reports with data on criminal, education, employment, and vehicle records, plus PEP screening.',
        points: [
            'Global Watchlist Search',
            'PEP and US Sanctions List Search',
            'Active Crime Monitoring',
        ],
        cta: {
            text: 'Get Started',
            link: 'https://portal.authenticate.com/register?utm_source=industry&utm_medium=finance&utm_campaign=scroll',
            external: true,
        },
        img: IFP_STEP_3,
    },
];

export const ID_FRAUDS = {
    DATA_1: {
        icon: ICON_SHIELD,
        heading: 'AI & ML Fraud is Rising',
        desc: `Did you know that every day, 400 companies in North America are targeted by deepfake fraud? Is your business prepared to handle this growing threat? Scammers are now using synthetic IDs and deepfakes—they've gotten smarter, and so have we.`,
        points: [
            'Over 200 Datapoints Analysed',
            'Liveness Checks',
            'Real-Time Forensic Analysis',
            'Email, Phone and Address Verification',
        ],
        img: ID_FRAUD_IMG_1,
    },
    DATA_2: {
        icon: ICON_DOLLAR,
        heading: 'KYC/AML Compliance is Expensive ',
        desc: `But it doesn't need to be! You get the most accurate and authentic data-driven solutions that won't break the bank.  The highest level of protection with i-Beta Level 2 spoof detection and the most comprehensive data protection and compliance standards.`,
        points: [
            'No Long-Term Contracts',
            'Global Coverage',
            'No Monthly minimums',
            'SOC II, HIPPA & GDPR Compliant',
        ],
        img: ID_FRAUD_IMG_2,
    },
};

export const MARKETPLACE_FRAUDS = {
    DATA_1: {
        icon: ICON_SHIELD,
        heading: 'Chargebacks Are Draining Your Profits',
        desc: 'Implement a robust fraud prevention solution that securely monitors every user, ensuring trust and compliance. Analyze user behavior in real-time, generate confidence scores, and verify that the payer and cardholder are the same individuals.',
        points: [
            'User Risk Scores',
            'Confidence Scores on PII',
            'Age Verification',
            'Instant Identity Proof Quiz',
        ],
        img: MARKETPLACE_FRAUD_IMG_1,
    },
    DATA_2: {
        icon: ICON_DOLLAR,
        heading: 'Affordable Security with Compliance',
        desc: 'Achieve GDPR, HIPAA, and SOC 2 compliance without breaking the bank. Access instant screening reports fortified with top-tier security and compliance standards. Start now with no minimums or long-term contracts. Enjoy global coverage at an affordable price.',
        points: [
            'No Long-Term Contracts',
            'Global Coverage',
            'No Monthly minimums',
            'SOC II, HIPPA & GDPR Compliant',
        ],
        img: MARKETPLACE_FRAUD_IMG_2,
    },
};

export const ID_FRAUD_PREVENTIONS = {
    DATA_1: {
        id: 1,
        heading: 'AML Screening with Deep Background Checks',
        subText:
            'AML screening with in-depth background checks to prevent fraud & enhance security.',
        img: FRAUD_PREVENTION_IMG_1,
        points: [
            'Screens for sanctions, PEPs, & media watchlists',
            'Verifies identities in real-time during onboarding',
            'Provides checks throughout the customer lifecycle',
        ],
        cta: {
            isPopup: true,
            text: 'Schedule a Demo',
        },
    },
    DATA_2: {
        id: 2,
        heading: 'Customer Onboarding and Instant KYC',
        subText:
            'With rising fraud and remote onboarding demands, banks urgently require secure verification solutions.',
        img: FRAUD_PREVENTION_IMG_2,
        points: [
            'Uses AI, computer vision, machine learning',
            'Reliably verifies remote users',
            'Reduces fraud risk, streamlines onboarding',
        ],
        cta: {
            text: 'Instant Fraud Prevention',
            link: '/solutions/kyc-aml-compliance',
        },
    },
};

export const MARKETPLACE_FRAUD_PREVENTIONS = {
    DATA_1: {
        id: 1,
        heading: 'Marketplace Identity Verification',
        subText:
            'As identity theft rises, make sure that you know who you are interacting with & make each interaction safe & secure.',
        img: MARKETPLACE_FRAUD_PREVENTION_IMG_1,
        points: [
            'Verify Identity under 30 Seconds',
            'Continuous Monitoring with Instant Updates',
            'Automatic Business Verification',
        ],
        cta: {
            isPopup: true,
            text: 'Schedule a Demo',
        },
    },
    DATA_2: {
        id: 2,
        heading: 'Fraud Prevention & Background Checks',
        subText:
            'Instant, Accurate, and Affordable Fraud prevention with comprehensive background reports at your fingertips.',
        img: MARKETPLACE_FRAUD_PREVENTION_IMG_2,
        points: [
            'Screen from 40+ Watchlists',
            'County, & Sex Offender Registry Screening',
            'Seamless Automated Onboarding',
        ],
        cta: {
            text: 'Instant Fraud Prevention',
            link: '/solutions/identity-fraud-prevention',
        },
    },
};

export const FINANCE_PAGE_RESOURCES = [
    {
        id: 1,
        link: 'https://authenticate.com/resources/blog/customer-onboarding',
        banner: FINANCE_BLOG_IMG,
        tag: 'Blog',
        tagColor: '#B54708',
        tagBackgroundColor: '#FFFAEB',
        title: 'Simplify Customer Onboarding with Advanced ID Verification & KYC Compliance',
        description:
            'Discover how Authenticate enhances your customer onboarding process by resolving common pain points with advanced ID verification and KYC compliance solutions, leading to increased customer satisfaction and business growth.',
        cardType: 'blog',
    },
    COMMON_SOLUTION_RESOURCE,
    COMMON_KB_RESOURCE,
];

export const MARKETPLACES_PAGE_RESOURCES = [
    {
        id: 1,
        link: 'https://authenticate.com/resources/blog/identity-verification-reasons',
        banner: MARKETPLACE_BLOG_IMG,
        tag: 'Blog',
        tagColor: '#B54708',
        tagBackgroundColor: '#FFFAEB',
        title: 'Reasons Your Business Should Prioritize Identity Verification',
        description:
            'Prioritize identity verification (IDV) to ensure regulatory compliance, prevent fraud, and enhance customer trust. Learn why robust IDV solutions are essential for safeguarding your business in today’s digital economy.',
        cardType: 'blog',
    },
    {
        id: 2,
        link: 'https://authenticate.com/solutions/kyc-aml-compliance/',
        banner: MARKETPLACE_SOLUTION_IMG,
        tag: 'Solutions',
        tagColor: '#C11574',
        tagBackgroundColor: '#FDF2FA',
        title: 'Detect Bad Actors and Prevent Fraud with Identity',
        description:
            'Ensure compliance with international standards and safeguard against deepfakes and AI-driven fraud with instant Identity verification and real-time confidence ratings on selfies.',
        cardType: 'product',
    },
    COMMON_KB_RESOURCE,
];

export const FINANCE_PAGE_FAQS = [
    {
        id: 0,
        title: 'How does Authenticate streamline customer onboarding for financial institutions?',
        desc: `Authenticate enhances customer onboarding by leveraging global identity verification and advanced AML screening to provide a seamless experience. It verifies over 7,500 types of government-issued IDs from 196 countries in just 30 seconds. Utilizing AI and machine learning, it analyzes facial landmarks for liveness and face matching, reducing fraud risk while expediting the onboarding process.`,
    },
    {
        id: 1,
        title: 'What methods does Authenticate use for identity verification and fraud prevention?',
        desc: 'Authenticate employs a multi-layered approach to identity verification and fraud prevention. It analyzes emails, phone numbers, and social profiles against a proprietary identity graph to generate a confidence score out of 99. Real-time forensic analysis examines over 200 data points to detect synthetic IDs and deepfakes, while liveness checks and face matching ensure the user’s live presence and identity.',
    },
    {
        id: 2,
        title: 'How does Authenticate assist with AML compliance and screening?',
        desc: 'Authenticate offers comprehensive AML screening solutions by providing global watchlist searches against over 50 national and international sanction lists. It identifies Politically Exposed Persons and individuals on U.S. sanctions lists, and offers active crime monitoring. Detailed PDF reports cover criminal, education, employment, and motor vehicle records, helping institutions meet regulatory obligations and reduce fraud risk.',
    },
    {
        id: 3,
        title: "How to integrate Authenticate's solutions into existing systems?",
        desc: 'Integration with Authenticate is designed to be seamless and user-friendly. The no-code portal allows for quick setup and onboarding without the need for a development team. For advanced setups, robust APIs provide seamless integration options. Businesses can set up within minutes and start protecting themselves from fraud immediately, whether they have technical expertise or not.',
    },
];

export const MARKETPLACE_PAGE_FAQS = [
    {
        id: 0,
        title: 'How does Authenticate perform marketplace identity verification?',
        desc: 'Our marketplace identity verification leverages instant identity quizzes, government ID and selfie verification, and real-time age and address checks. This multi-layered approach ensures that both buyers and sellers are who they claim to be, enhancing trust and security on your platform. By analyzing user behavior in real time and generating confidence scores, we help you onboard customers swiftly while mitigating risks.',
    },
    {
        id: 1,
        title: 'What methods does Authenticate use to prevent marketplace fraud?',
        desc: 'We implement AI and machine learning-based fraud prevention mechanisms that monitor user activity continuously. Our solution provides user risk scores and confidence scores on personally identifiable information (PII), helping you verify that the payer and cardholder are the same individual. This robust system reduces the likelihood of fraudulent transactions and chargebacks, protecting your profits.',
    },
    {
        id: 2,
        title: 'How quickly can we integrate Autehnticate’s solutions into our platform?',
        desc: "You can integrate our identity verification APIs in less than a day. We offer customizable and branded workflows to ensure a seamless user experience. Additionally, you can test our services with mock APIs before full integration. Our solution is designed for hassle-free implementation, allowing you to enhance your platform's security promptly.",
    },
    {
        id: 3,
        title: 'Is Authenticate compliant with GDPR, HIPAA, and SOC 2 regulations?',
        desc: 'Yes, our services are fully compliant with GDPR, HIPAA, and SOC 2 standards. We prioritize top-tier security and compliance to protect user data and help you meet regulatory requirements. This ensures that you can operate confidently across different regions, knowing that you adhere to international data protection laws.',
        link: 'https://authenticate.com/resources/security-and-compliance',
        linkText: 'Learn More about how we prioritise your security',
    },
    {
        id: 4,
        title: 'How does Authenticate’s pricing work?',
        desc: 'Our services are provided without long-term contracts and monthly minimums, making them affordable for businesses of all sizes. You can start using our global coverage solutions immediately without significant upfront commitments, allowing you to scale as needed while maintaining unparalleled accuracy in identity verification and fraud prevention.',
    },
];

export const MARKETPLACE_AUTHENTICATE_DATA = [
    {
        id: 0,
        title: 'Customer Onboarding',
        points: [
            'Instant Identity Quiz',
            'Government ID & Selfie Verification',
            'Real-Time Age and Address Verification',
        ],
    },
    {
        id: 1,
        title: 'Screen Sellers',
        points: [
            'Instant Screenings',
            'Access AML Screening Reports',
            'KYB with FEINS and DUNS Matching',
        ],
    },
    {
        id: 2,
        title: 'Increase Conversion Rates',
        points: [
            'Test with Mock APIs',
            'Customizable and Branded Workflows',
            'True Continuous Monitoring™',
        ],
    },
];

// ==============================HEALTHCARE_PAGE===========================
export const HEALTHCARE_PAGE_AUTHENTICATION_STEPS = [
    {
        id: 1,
        icon: ICON_USER_FRAME,
        heading: 'Patient Onboarding',
        desc: 'Instantly onboard patients with online ID verification before visits. Patients snap a selfie; our AI matches it to their photo ID, ensuring they are who they claim.',
        points: [
            'No Human Intervention Required',
            'Government ID & Selfie Verification',
            'Customise Workflows with Tailored Experiences',
        ],
        cta: {
            text: 'Read More',
            link: '/products/identity',
            external: false,
        },
        img: Healthcare_step_1,
    },
    {
        id: 2,
        icon: ICON_BAR,
        heading: 'Prevent Healthcare Fraud',
        desc: `Let us handle the complexities of patient identity verification, risk analysis, and fraud detection—we stay ahead so you don't have to. As healthcare regulations evolve, we ensure HIPAA compliance, letting you focus on what truly matters.`,
        points: [
            'Sex Offender Check',
            'User Behavioral Insights',
            'Instant Criminal Background Checks',
        ],
        cta: {
            text: 'Learn More',
            link: 'https://authenticate.com/products/criminal-background-checks',
            external: false,
        },
        img: Healthcare_step_2,
    },
    {
        id: 3,
        icon: ICON_PAPER,
        heading: 'Safeguard Electronic Health Records ',
        desc: 'Prevent unauthorised access to EHR. Integrate your EHR system with Authenticate to provide a seamless onboarding experience to patients and healthcare providers.',
        points: [
            'Fast and Scalable APIs',
            'HIPPA & GDPR Compliant',
            'i-Beta Level 2 Spoofing Protection',
        ],
        cta: {
            text: 'Learn More',
            link: 'https://portal.authenticate.com/register?utm_source=industry&utm_medium=finance&utm_campaign=scroll',
            external: true,
        },
        img: Healthcare_step_3,
    },
];

export const MEDICARE_FRAUDS = {
    DATA_1: {
        icon: ICON_SHIELD,
        heading: 'Minimize Human Intervention',
        desc: 'Completely automate patient verification and vendor screening. Run instant risk reports and get compliant downloadable reports with selfies and government IDs. Ensure trust with patients by screening healthcare contract workers.',
        points: [
            'Professional License Verification',
            'User Risk Scores',
            'Confidence Scores on PII',
            'Instant Criminal Screening ',
        ],
        img: Healthcare_fraud_img_1,
    },
    DATA_2: {
        icon: ICON_DOLLAR,
        heading: 'Affordable Compliance, Uncompromised Security',
        desc: `Achieve GDPR, HIPAA, and SOC 2 compliance without breaking the bank. Instantly access screening reports fortified with top-tier security and compliance standards. With robust DDoS protection and the highest encryption protocols, your patients' data is always safe and secure.`,
        points: [
            'Global Coverage',
            'SOC II, HIPPA & GDPR Compliant',
            'Encryption at REST and In-Transit',
            'Role-Based Access Control',
        ],
        img: Healthcare_fraud_img_2,
    },
};

export const HEALTHCARE_SEAMLESS_FRAUD_PREVENTION = {
    DATA_ONE: {
        id: 1,
        heading: (
            <>
                Patient Identity <br /> Verification
            </>
        ),
        subText:
            'Instant Patient Identity Proofing with full automation. Know Your Patient as soon as possible, even before the visit.',
        img: Healthcare_fraud_prevention_img_1,
        points: [
            'Verify Identity in 30 Seconds',
            'Continuous Monitoring with Instant Updates',
            'Automatic Business Verification',
        ],
        cta: {
            text: 'Learn More',
            link: '/solutions/identity-fraud-prevention',
        },
    },
    DATA_TWO: {
        id: 2,
        heading: (
            <>
                Mitigate Risks & <br /> Prevent Fraud
            </>
        ),
        subText:
            'Automating onboarding minimizes risk and potential losses by preventing fraudulent claims, including spousal fraud.',
        img: Healthcare_fraud_prevention_img_2,
        points: [
            'Comprehensive and Instant Background Checks',
            'Streamline Enrollment',
            'Detect Bad Actors',
        ],
        cta: {
            isPopup: true,
            text: 'Schedule a Demo',
        },
    },
};

export const HEALTHCARE_PAGE_RESOURCES = [
    {
        id: 'blog_resources_healthcare',
        link: 'https://authenticate.com/resources/blog/identity-verification-reasons',
        banner: Healthcare_Resource_img_1,
        tag: 'Blog',
        tagColor: '#B54708',
        tagBackgroundColor: '#FFFAEB',
        title: 'Reasons Your Business Should Prioritize Identity Verification',
        description: `Prioritize identity verification (IDV) to ensure regulatory compliance, prevent fraud, and enhance customer trust.`,
        cardType: 'blog',
    },
    COMMON_PRODUCT_RESOURCE,
    COMMON_KB_RESOURCE,
];

export const HEALTHCARE_PAGE_FAQS = [
    {
        id: 1,
        title: 'What is patient identity verification and why is it important in healthcare?',
        desc: 'Patient identity verification is the process of confirming a patient’s identity to ensure they receive the correct care, protect their sensitive data, and prevent medical errors or fraud.',
    },
    {
        id: 2,
        title: 'How does digital patient identity verification work?',
        desc: 'Digital patient identity verification uses technologies like biometric authentication, government-issued ID checks, and AI-powered liveness detection to confirm a patient’s identity online or in person.',
    },
    {
        id: 3,
        title: 'What are the benefits of using biometric verification for patients?',
        desc: 'Biometric verification, such as facial recognition or fingerprint scanning, provides a secure, fast, and user-friendly method to prevent impersonation and ensure only authorized patients access sensitive medical information.',
    },
    {
        id: 4,
        title: 'Is digital patient identity verification HIPAA compliant?',
        desc: 'Yes, when implemented correctly, digital identity verification solutions can comply with HIPAA and other regulations by encrypting data, securing patient information, and maintaining audit trails.',
    },
    {
        id: 5,
        title: 'What information is required for patient identity verification?',
        desc: 'Typically, patients are asked to provide government-issued photo ID, a selfie for biometric comparison, and sometimes additional details like date of birth or address to ensure accurate identification.',
    },
];
